var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35 0C3.64787 0 4.7 1.05213 4.7 2.35V3.4C4.7 4.44934 5.55066 5.3 6.6 5.3H7.65C8.94787 5.3 10 6.35213 10 7.65C10 8.94787 8.94787 10 7.65 10C6.35213 10 5.3 8.94787 5.3 7.65V6.6C5.3 5.55066 4.44934 4.7 3.4 4.7H2.35C1.05213 4.7 0 3.64787 0 2.35C0 1.05213 1.05213 0 2.35 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 2.35C9.6 3.42696 8.72696 4.3 7.65 4.3C6.57304 4.3 5.7 3.42696 5.7 2.35C5.7 1.27304 6.57304 0.4 7.65 0.4C8.72696 0.4 9.6 1.27304 9.6 2.35Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35 9.6C3.42696 9.6 4.3 8.72696 4.3 7.65C4.3 6.57304 3.42696 5.7 2.35 5.7C1.27304 5.7 0.4 6.57304 0.4 7.65C0.4 8.72696 1.27304 9.6 2.35 9.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloomIcon);
export default __webpack_public_path__ + "static/media/bloomIcon.11029c728828be681c634696695f8993.svg";
export { ForwardRef as ReactComponent };